import { useCallback } from "react";

import { Activity, Company, Deal, Person } from "@mapmycustomers/shared/types/entity";

const useEntityClickHandlers = (
  activity: Activity,
  onCompanyClick?: (companyId: Company["id"]) => void,
  onPersonClick?: (personId: Person["id"]) => void,
  onDealClick?: (dealId: Deal["id"]) => void
) => {
  const handleCompanyClick = useCallback(
    (e) => {
      if (!onCompanyClick || !activity.account) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      onCompanyClick(activity.account.id);
    },
    [activity, onCompanyClick]
  );

  const handlePersonClick = useCallback(
    (e) => {
      if (!onPersonClick || !activity.contact) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      onPersonClick(activity.contact.id);
    },
    [activity, onPersonClick]
  );

  const handleDealClick = useCallback(
    (e) => {
      if (!onDealClick || !activity.deal) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      onDealClick(activity.deal.id);
    },
    [activity, onDealClick]
  );

  return [handleCompanyClick, handlePersonClick, handleDealClick];
};

export default useEntityClickHandlers;
